import React, {useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  MFAContainer,
} from "../styled";

import STRATEGIC_PARTNER from "../../constants/strategicPartners";

import {EmailToVerified} from "./emailToVerified"
import {AuthAppToVerified} from "./authAppToVerified"
import {MFA_TYPE} from "../constants";
import {BackUpCodes} from "./backUpCodes";
import {PreviewEmailToVerified} from "./previewEmailToVerified";
import {Header} from "semantic-ui-react";
import {ClickableText, CustomContainer, CustomDivider, CustomGrid} from "../../components/custom-common";

const ValidateMFA = (props) => {

  const {
    userName,
    mfaToken,
    redirectPath,
    loginPath,
    rememberDeviceDays,
    mfaTypesConfigured,
    mfaEmailSetUpped
  } = props;

  const [submitted, setSubmitted] = useState(false)
  const [previewEmailWasChecked, setPreviewEmailWasChecked] = useState(false)
  const [usingMethod, setUsingMethod] = useState({
    [MFA_TYPE.EMAIL]: false,
    [MFA_TYPE.TOTP]: false,
    [MFA_TYPE.SMS]: false,
    backUpCodes: false,
  })
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if(mfaTypesConfigured?.length === 1) {
      handleUseMethod(mfaTypesConfigured[0])
      handleSubmit()
    }
  }, [mfaTypesConfigured]);

  const redirectToLogin = (isLocked) => {
    history.push({ pathname: loginPath, isLocked});
  };

  const handleUseMethod = (method) => {
    setUsingMethod(prevState => ({
      [MFA_TYPE.EMAIL]: false,
      [MFA_TYPE.TOTP]: false,
      [MFA_TYPE.SMS]: false,
      [MFA_TYPE.BACKUP_CODES]: false,
      [method]: true
    }))
  }

  const handleSubmit = () => setSubmitted(true)

  const handleCheckPreview = () => setPreviewEmailWasChecked(true)

  return (
    <>
      <MFAContainer
        style={{ paddingTop: "125px", textAlign: "center" }}
      >
        <Header as="h2" textAlign="center">
          Authentication code required
        </Header>
        <CustomGrid fitted column={1} className={'mfaAuthCodeContainer'}>
          <CustomContainer padded textAlign={'left'}>

            {submitted && (
                <>
                  {usingMethod[MFA_TYPE.EMAIL] && (
                      <>
                        {!previewEmailWasChecked && (
                            <PreviewEmailToVerified
                                mfaEmailSetUpped={mfaEmailSetUpped}
                                userName={userName}
                                mfaToken={mfaToken}
                                handleCheckPreview={handleCheckPreview}
                                handleUseMethod={handleUseMethod}
                            />
                        )}

                        {previewEmailWasChecked && (
                            <EmailToVerified
                                mfaEmailSetUpped={mfaEmailSetUpped}
                                userName={userName}
                                mfaToken={mfaToken}
                                handleUseMethod={handleUseMethod}
                                redirectPath={redirectPath}
                                history={history}
                                dispatch={dispatch}
                                redirectToLogin={redirectToLogin}
                                rememberDeviceDays={rememberDeviceDays}
                            />
                        )}
                      </>
                  )}
                </>
            )}

            {submitted && (
                <>
                  {usingMethod[MFA_TYPE.TOTP] && (
                      <AuthAppToVerified
                          userName={userName}
                          mfaToken={mfaToken}
                          redirectPath={redirectPath}
                          history={history}
                          dispatch={dispatch}
                          redirectToLogin={redirectToLogin}
                          rememberDeviceDays={rememberDeviceDays}
                          handleUseMethod={handleUseMethod}
                      />
                  )}
                </>
            )}

            {usingMethod.backUpCodes && (
                <BackUpCodes
                    mfaToken={mfaToken}
                    redirectPath={redirectPath}
                    history={history}
                    dispatch={dispatch}
                    redirectToLogin={redirectToLogin}
                />
            )}
          </CustomContainer>

          <div className="backupCodeText">
            {usingMethod.backUpCodes && (
                <>
                  <p className={'small'}>
                    Still having trouble? Contact us at{" "}
                    <a href={`mailto:${STRATEGIC_PARTNER.CONTACT_SUPPORT.EMAIL}`}>{STRATEGIC_PARTNER.CONTACT_SUPPORT.EMAIL}</a>{" "}
                    or call {STRATEGIC_PARTNER.CONTACT_SUPPORT.NUMBER}.
                  </p>
                  <CustomDivider smaller hidden/>
                </>
            )}
            <ClickableText
                onClick={() => redirectToLogin()}
                small
            >
              Return to login screen
            </ClickableText>
          </div>
        </CustomGrid>
      </MFAContainer>
    </>
);
};

export default ValidateMFA;
